import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import NavbarAll from '../Navbar/NavbarAll';

const EventDetail = () => {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;

  const { id } = useParams();

  // Optional: Convert regular YouTube URL to embed format
  const toEmbedUrl = (url) => {
    if (!url) return null;
    return url.replace("watch?v=", "embed/");
  };

  useEffect(() => {
    const fetchEventData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/events/${id}`);
        setEvent(response.data);
        setLoading(false);
      } catch (err) {
        setError('Error fetching event details');
        setLoading(false);
      }
    };

    fetchEventData();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <>
      <NavbarAll />
      <div>
        {/* Hero Section */}
        <section className="w-100 pt-80 pb-70 black-layer position-relative">
          <div
            className="fixed-bg"
            style={{
              backgroundImage: `url(${event.imageUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
          <div className="container">
            <div className="page-title-wrap text-center w-100">
              <div className="page-title-inner d-inline-block">
                <h1 className="mb-0 text-white text-5xl font-bold">{event.title}</h1>
                <p className="text-white text-lg mt-2">Join us for an insightful event!</p>
              </div>
            </div>
          </div>
        </section>

        {/* Event Details Section */}
        <section style={{ width: '100%', padding: '20px 0' }}>
          <div
            style={{
              maxWidth: '1100px',
              margin: '0 auto',
              padding: '20px',
              backgroundColor: '#fff',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              borderRadius: '16px',
              display: 'flex',
              flexWrap: 'wrap',
              gap: '20px',
            }}
          >
            {/* Image Card */}
            <div
              style={{
                flex: '1',
                minWidth: '300px',
                maxWidth: '400px',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  width: '100%',
                  height: '400px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                }}
              >
                <img
                  src={event.imageUrl}
                  alt={event.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </div>

            {/* Event Details */}
            <div
              style={{
                flex: '2',
                minWidth: '300px',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <h2 style={{ fontSize: '32px', fontWeight: 'bold', color: '#2563eb', marginBottom: '20px' }}>
                {event.title}
              </h2>

              <p style={{ color: '#4b5563', marginBottom: '10px' }}>
                <strong>📅 Date:</strong> {new Date(event.date).toLocaleDateString()} at {new Date(event.date).toLocaleTimeString()}
              </p>

              <p style={{ color: '#374151', marginBottom: '20px' }}>
                {event.description}
              </p>

              {/* Optional Video Frame */}
              {event.videoUrl && (
                <div
                  style={{
                    marginBottom: '20px',
                    position: 'relative',
                    paddingBottom: '56.25%', // 16:9
                    height: 0,
                    overflow: 'hidden',
                    borderRadius: '12px',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  }}
                >
                  <iframe
                    src={toEmbedUrl(event.videoUrl)}
                    title="Event Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                    }}
                  ></iframe>
                </div>
              )}

              {/* Register Button (only if event is upcoming) */}
              {new Date(event.date) > new Date() && (
                <div style={{ marginTop: 'auto', textAlign: 'center' }}>
                  <a
                    href={event.registrationLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-block',
                      padding: '12px 24px',
                      background: 'linear-gradient(to right, #3b82f6, #6366f1)',
                      color: '#fff',
                      fontWeight: '600',
                      borderRadius: '8px',
                      textDecoration: 'none',
                      transition: 'transform 0.3s ease',
                    }}
                    onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
                  >
                    Register Now
                  </a>
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EventDetail;
